import { API_URL } from "@/mainconfig";

const state = {
    roomRatingTypes: [], // Simpan data jenis rating
    error: null, // Untuk menyimpan error jika ada
    loading: false, // Status loading untuk operasi pengambilan data
};

const getters = {
    getRoomRatingTypes: (state) => state.roomRatingTypes, // Data jenis rating
    isLoading: (state) => state.loading, // Apakah dalam status loading
    getReviewError: (state) => state.error, // Pesan error
};

const actions = {
    // GET roomRating/getAllTypes
    async fetchRoomRatingTypes({ commit }) {
        commit("setLoading", true); // Aktifkan loading state
        try {
            const response = await API_URL.get("/roomRating/getAllTypes"); // Panggil endpoint
            const ratingTypes = response.data?.data || []; // Ambil data dari response
            console.log("Fetched Room Rating Types:", ratingTypes); // Tambahkan log hasil fetch
            commit("setRoomRatingTypes", ratingTypes); // Set data jenis rating ke state
            commit("setError", null); // Bersihkan error jika sukses
            return ratingTypes; // Kembalikan data untuk digunakan di komponen
        } catch (error) {
            commit(
                "setError",
                error.response?.data?.msg ||
                    "Failed to fetch room rating types."
            );
            throw error;
        } finally {
            commit("setLoading", false); // Nonaktifkan loading state
        }
    },

    // POST roomRating
    async submitRoomRating({ commit }, payload) {
        commit("setLoading", true); // Aktifkan loading state
        try {
            const response = await API_URL.post("/roomRating", payload); // Kirim data ke endpoint
            commit("setError", null); // Bersihkan error jika sukses
            return response.data; // Kembalikan response untuk konfirmasi
        } catch (error) {
            commit(
                "setError",
                error.response?.data?.msg || "Failed to submit room rating."
            );
            throw error;
        } finally {
            commit("setLoading", false); // Nonaktifkan loading state
        }
    },
};

const mutations = {
    setRoomRatingTypes(state, roomRatingTypes) {
        // Set data jenis rating ke state
        state.roomRatingTypes = roomRatingTypes;
    },
    setLoading(state, loading) {
        // Set status loading
        state.loading = loading;
    },
    setError(state, error) {
        // Set error jika terjadi masalah
        state.error = error;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
